import React from "react";

export default function Graph() {
  return (
    <div className="guides">
      <h5>
        <span className="purple"></span> Graphs
      </h5>
      <div className="guides__text mx">
        <p className="rm">
          <strong color="white">Portfolio</strong>
        </p>
        <p>
          Displays balance statistics for the day/week/month/year, depending on
          the selected filters.
        </p>
        <div className="guides__image box">
          <img src={process.env.PUBLIC_URL + "/images/chart.png"} alt="chart" />
        </div>
        <p className="rm">
          <strong color="white">Revenue</strong>
        </p>
        <p>
          Displays the total amount of invoices in $ per day/week/month/year,
          depending on the selected filters.
        </p>
        <div className="guides__image box">
          <img
            src={process.env.PUBLIC_URL + "/images/chart-2.png"}
            alt="chart"
          />
        </div>
        <p className="rm">
          <strong color="white">Market</strong>
        </p>
        <p>
          Reflects the percentage change in the amount of invoices from month to
          month.
        </p>
        <div className="guides__image box">
          <img
            src={process.env.PUBLIC_URL + "/images/chart-3.png"}
            alt="chart"
          />
        </div>
        <p>
          Note that the information on the monthly chart appears on the second
          month of using the platform!
        </p>
      </div>
    </div>
  );
}
